import React, { Component, Fragment } from 'react';
import {
  Container,
  Row, Col, Input, Button, Form, FormGroup
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import ConfirmButton from '../Modal/ConfirmButton';
class SalesOpportunitiesStatuses extends Component {

  standardRow = (status) => {
    const tagNames = [status.Tag1, status.Tag2, status.Tag3]
      .filter(Boolean)
      .map(tagID => this.props.opportunitiesTags.find(item => item.ID === parseInt(tagID, 10))?.Tag)
      .filter(Boolean)
      .join(', ');
    return (
      <Row className="adminRow pointer text-left" onClick={() => this.props.onEdit(status.ID)}>
        <Col md={3}>{status.Opportunity}</Col>
        <Col md={3}>{status.Description}</Col>
        <Col md={4}>{tagNames}</Col>
        <Col md={2}>{status.Hide ? '(Hidden)' : ''}</Col>
      </Row>
    )
  }

  editRow = (status) => {
    return (
      <Row className="editRow adminRow">
        <Col md={8} className="text-left">
          <Form inline>
            <FormGroup className="mr-2">
              <Input
                placeholder="Status"
                name="opportunity"
                value={this.props.editStatus.opportunity + ''}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="mr-2">
              <Input
                placeholder="Description"
                name="description"
                value={this.props.editStatus.description + ''}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="mr-2">
              <Input
                type="checkbox"
                name="hide"
                value={1}
                checked={this.props.editStatus.hide != null ? this.props.editStatus.hide : false}
                onChange={e => this.props.onChange(e, 'edit')} />  Set as Auto Hide
            </FormGroup>
            <FormGroup className="mr-2">
              <Input
                type="select"
                name="tag1"
                value={this.props.editStatus.tag1}
                onChange={e => this.props.onChange(e, 'edit')}>
                <option value="">SELECT STATUS GROUP</option>
                {this.props.opportunitiesTags.filter(opportunitiesTag => !opportunitiesTag.PrimaryCategory).map(opportunitiesTag => (
                  <option key={opportunitiesTag.ID} value={opportunitiesTag.ID}>{opportunitiesTag.Tag}</option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup className="mr-2">
              <Input
                type="select"
                name="tag2"
                value={this.props.editStatus.tag2}
                onChange={e => this.props.onChange(e, 'edit')}>
                <option value="">SELECT CATEGORY</option>
                {this.props.opportunitiesTags.filter(opportunitiesTag => opportunitiesTag.PrimaryCategory).map(opportunitiesTag => (
                  <option key={opportunitiesTag.ID} value={opportunitiesTag.ID}>{opportunitiesTag.Tag}</option>
                ))}
              </Input>
            </FormGroup>
            {this.props.supportsMultipleCategories && <FormGroup className="mr-2">
              <Input
                type="select"
                name="tag3"
                value={this.props.editStatus.tag3 || ''}
                onChange={e => this.props.onChange(e, 'edit')}>
                <option value="">SELECT SECOND CATEGORY (OPTIONAL)</option>
                {this.props.opportunitiesTags.filter(opportunitiesTag => opportunitiesTag.PrimaryCategory).map(opportunitiesTag => (
                  <option key={opportunitiesTag.ID} value={opportunitiesTag.ID}>{opportunitiesTag.Tag}</option>
                ))}
              </Input>
            </FormGroup>}
          </Form>
        </Col>
        <Col md={4} className="text-right">
          <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit Status">
            <FontAwesomeIcon icon={faCheck} />
          </Button>
          <ConfirmButton className="mx-3" color="danger" onClick={() => this.props.onDelete(status.ID)} edit="Delete Status">
            <FontAwesomeIcon icon={faTrashAlt} />
          </ConfirmButton>
          <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Col>
      </Row>
    )
  }

  addRow = () => {
    return (<Row className="py-4 text-left align-items-bottom">
      <Col md={8}>
        <Form inline>
          <FormGroup className="mr-2">
            Add New Status
          </FormGroup>
          <FormGroup className="mr-2">
            <Input
              placeholder="Status"
              name="opportunity"
              value={this.props.newStatus.opportunity + ''}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
          <FormGroup className="mr-2">
            <Input
              placeholder="Description"
              name="description"
              value={this.props.newStatus.description + ''}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
          <FormGroup className="mr-2">
            <Input
              type="checkbox"
              name="hide"
              checked={this.props.newStatus.hide != null ? this.props.newStatus.hide : false}
              onChange={e => this.props.onChange(e)} /> Set as Auto Hide
          </FormGroup>
          <FormGroup className="mr-2">
            <Input
              type="select"
              name="tag1"
              value={this.props.newStatus.tag1}
              onChange={e => this.props.onChange(e)}>
              <option value="">SELECT STATUS GROUP</option>
              {this.props.opportunitiesTags.filter(opportunitiesTag => !opportunitiesTag.PrimaryCategory).map(opportunitiesTag => (
                <option key={opportunitiesTag.ID} value={opportunitiesTag.ID}>{opportunitiesTag.Tag}</option>
              ))}
            </Input>
          </FormGroup>
          <FormGroup className="mr-2">
            <Input
              type="select"
              name="tag2"
              value={this.props.newStatus.tag2}
              onChange={e => this.props.onChange(e)}>
              <option value="">SELECT CATEGORY</option>
              {this.props.opportunitiesTags.filter(opportunitiesTag => opportunitiesTag.PrimaryCategory).map(opportunitiesTag => (
                <option key={opportunitiesTag.ID} value={opportunitiesTag.ID}>{opportunitiesTag.Tag}</option>
              ))}
            </Input>
          </FormGroup>
          {this.props.supportsMultipleCategories && <FormGroup className="mr-2">
            <Input
              type="select"
              name="tag3"
              value={this.props.newStatus.tag3 || ''}
              onChange={e => this.props.onChange(e)}>
              <option value="">SELECT SECOND CATEGORY (OPTIONAL)</option>
              {this.props.opportunitiesTags.filter(opportunitiesTag => opportunitiesTag.PrimaryCategory).map(opportunitiesTag => (
                <option key={opportunitiesTag.ID} value={opportunitiesTag.ID}>{opportunitiesTag.Tag}</option>
              ))}
            </Input>
          </FormGroup>}
        </Form>
      </Col>
      <Col md={4} className="text-right">
        <Button
          disabled={this.props.newStatus.opportunity === '' || this.props.newStatus.description === ''}
          color="primary"
          onClick={this.props.handleAdd}>
          Add Status
        </Button>
      </Col>
    </Row>
    )
  }

  render() {
    return (
      <Container className="adminContainer" fluid>
        {this.props.statuses.map(status => (
          <Fragment key={status.ID}>{this.props.editStatus.id === status.ID ? this.editRow(status) : this.standardRow(status)}</Fragment>
        ))}
        {this.addRow()}
      </Container>
    );
  }
}

export default SalesOpportunitiesStatuses;
